import { render, staticRenderFns } from "./CommonTaskIcon.vue?vue&type=template&id=4c63b87c&scoped=true"
import script from "./CommonTaskIcon.vue?vue&type=script&lang=js"
export * from "./CommonTaskIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c63b87c",
  null
  
)

export default component.exports